import { Checkbox, ComboBox, DefaultButton, IComboBoxOption, Label, Panel, PanelType, PrimaryButton, TextField, TooltipHost } from '@fluentui/react';
import { Column, FunctionHost, Guid, GuidLegacy, Row } from '@ioip/core/lib';
import { CForm, UXForm } from '@ioip/procesox/lib';
import { DateTime, IDataTableRequest, IDictionary, IFileUploadItem, IPaginationBase, ScriptComponent, isNullOrEmpty, paginateDataAsync } from 'ioip-base/lib/common';
import { List } from 'linq.ts';
import React from 'react';
import { AuthenticationState, LoginType, MsalAuthProvider } from "react-aad-msal";
import { IRadicadoEntradaExtended, defaultIRadicadoEntradaExtended } from '../../classes/radicado-entrada-extended';
import { Sede } from '../../classes/shared';
import { TramiteEnum } from '../../classes/shared/tramite.enum';
import { $_, EstadoRadicado, IClasificacionPQRS, IRadicadoSalida, ITipoSolicitante, ITramite, IValorMetadato, TipoAsignacionTramiteEnum, TipoContacto, TipoEjecucionGestionTramiteEnum, TipoRespuestaPQRS, TipoTramite, ValidationResult, createOptions, defaultITramite, ensureFetch, showConfirmation, showError, validateObject, validator } from '../../ioip/sdk/base';
import { LayoutEditorComponent } from '../../ioip/sdk/new-component';
import { PqrWebService } from '../../services/services';
import IoipBaseComponent from '../base.component';
import ReFileUploader from '../file-selector/ReFileUploader';
import { ReCaptchaComponent } from '../recaptcha/recaptcha.component';
import './crear-solicitud.css';
import { ICrearSolicitudComponentProps } from './crear-solicitud.props';
import { ICrearSolicitudComponentState, defaultICrearSolicitudComponentState } from './crear-solicitud.state';
import { CreatePqrComponentMode } from './create-pqr-mode.enum';
import { JSPage } from '@ioip/procesox/lib/forms/types/JSPage';

class CrearSolicitudComponent extends IoipBaseComponent<ICrearSolicitudComponentProps, ICrearSolicitudComponentState> {

  _service: PqrWebService;
  _tramites: ITramite[];
  _clasificaciones: IClasificacionPQRS[];
  _editorMetadatosComponent: LayoutEditorComponent;
  _scriptComponentRef: ScriptComponent;
  private _recaptcha: ReCaptchaComponent;
  private _authProvider: MsalAuthProvider;
  private _pqrWebService: PqrWebService;
  private _limiteAsunto: number = 1000;
  private _campoObservacion: boolean = false;

  get contactTypeId(): number {
    const anonymousContactType = TipoContacto.Anonimo;
    const contactTypeId: number = this.props.mode === CreatePqrComponentMode.Create ? Number(sessionStorage.getItem('ioip.pqr-web.session.idtipocontacto')) : anonymousContactType;
    return contactTypeId;
  }

  get entityTypeId(): number {
    const entityTypeId: number = this.props.mode === CreatePqrComponentMode.Create ? Number(sessionStorage.getItem('ioip.pqr-web.session.idtipoentidad')) : 0;
    return entityTypeId;
  }

  get sessionId(): string {
    const url = window.location.href.split('/').pop();
    return url || '';
  }

  constructor(props: any) {
    super(props);
    this.state = defaultICrearSolicitudComponentState();
    this._service = new PqrWebService();

    this._authProvider = new MsalAuthProvider(
      {
        auth: {
          authority: Sede.Shared.Context.B2C.Authority,
          clientId: Sede.Shared.Context.B2C.ClientId,
          postLogoutRedirectUri: window.location.origin + '/sede.html',
          redirectUri: window.location.origin + '/sede.html',
          validateAuthority: false,
        },
        cache: {
          cacheLocation: "localStorage",
          storeAuthStateInCookie: true
        }
      },
      {
        scopes: [ Sede.Shared.Context.B2C.Scopes ]
      },
      {
        loginType: LoginType.Popup,
        tokenRefreshUri: window.location.origin
      }
    );

    this._pqrWebService = new PqrWebService();
  }

  async componentDidMount(): Promise<void> {
    try {

      if (this.props.mode === CreatePqrComponentMode.CreateAnonymous) {
        sessionStorage.setItem('ioip.pqr-web.session.idtipocontacto', TipoContacto.Anonimo.toString());
      }

      let [ model, identifications ] = await Promise.all([
        GuidLegacy.IsValid(this.sessionId) ? this._service.getSessionDraftAsync(this.sessionId) : this._service.getCurrentDraftAsync(),
        this._service.getAllIdentificationTypesAsync()
      ]);

      const [ applicantTypes ] = await Promise.all([
        this._pqrWebService.getAllApplicantTypeAsync()
      ]) as any;

      let lastRequest = '';
      if (!GuidLegacy.IsValid(this.sessionId)) lastRequest = await Promise.all([ this._pqrWebService.getLastRequest() ]) as any;

      this._tramites = Sede.Shared.Context.Tramites.filter(o => o.Activo && o.TiposContacto?.some(x => x.ContactTypeId == this.contactTypeId));
      let tiposActuacion = this.state.data.tiposActuacion;
      let labelsDenunciante = this.state.labelsDenunciante;
      if (this.contactTypeId == TipoContacto.Congresista) {
        tiposActuacion = [
          { key: 2, text: 'En nombre propio' },
          { key: 1, text: 'Solicitud ciudadana presentada en la oficina de congresista' }
        ];
        labelsDenunciante = {
          nombre: 'Nombres denunciante',
          apellido: 'Apellidos denunciante',
          tipoIdentificacion: 'Tipo de identificacion denunciante',
          numeroIdentificacion: 'Identificación denunciante',
          email: 'Email denunciante'
        };
      }

      let numeroVinculado = model ? model.NumeroRadicadoSalida : '';
      if (Sede.Shared.Context.SubjectMaxLength > 0)
        this._limiteAsunto = Sede.Shared.Context.SubjectMaxLength;
      if (Sede.Shared.Context.EnableCommentsField)
        this._campoObservacion = Sede.Shared.Context.EnableCommentsField;
      const attachments = this.processDocuments(model);

      if (model == null)
        model = defaultIRadicadoEntradaExtended();
      if (this.defaultTramiteId > 0)
        model.IdTramite = this.defaultTramiteId;


      this.setState({
        model,
        data: {
          ...this.state.data,
          tramitesCO: createOptions(this._tramites.filter(x => x.Activo && !x.Props?.ShowButtonInWeb), o => o.IdTramite, o => o.Nombre),
          tiposIdentificacion: identifications.map(o => ({ key: o.IdTipoIdentificacion, text: o.Nombre })),
          tiposActuacion,
          tiposSolicitante: applicantTypes.filter(o => o.Activo).map((o: ITipoSolicitante) => ({ key: o.IdTipoSolicitante, text: o.Nombre }))
        },
        labelsDenunciante,
        attachments,
        procesoxFunction: '',
        NumeroRadicadoSalida: numeroVinculado
      }, () => {
        this._onChangeTramite({
          key: this.state.model.IdTramite
          , text: this.state.model.Tramite
        }, model?.CustomMetadata, false);
      });

      this._getTokenB2C();

      if (!isNullOrEmpty(lastRequest[ 0 ])) {
        alert(lastRequest);
      }

    } catch (err) {
      if (err instanceof Error) {
        alert(err.message);
      }
    }
  }

  /**
   * Retorna el Id del trámite seleccionado a traves del parametro tramiteId en la url
   */
  private get defaultTramiteId(): number {
    let tramiteId = 0;
    if (window.location.href.includes('?tramiteId='))
      tramiteId = Number(window.location.href.split('?tramiteId=')[ 1 ]);
    return tramiteId;
  }

  processDocuments(model: IRadicadoEntradaExtended): IFileUploadItem[] {
    if (model == null) {
      return [];
    }
    const attachments: IFileUploadItem[] = [];
    if (model.Anexos?.length > 0) {
      for (let i = 0; i < model.Anexos.length; i++) {
        const attachment = model.Anexos[ i ];
        attachments.push({
          name: attachment.NombreArchivo,
          nativeFile: null,
          size: attachment.Length,
          data: attachment,
          error: !attachment.Cargado,
          uploadId: GuidLegacy.NewGuid(),
        });
      }
    }
    return new List<IFileUploadItem>(attachments).OrderBy(o => o.name).ToArray();
  }

  //#region Propiedades

  get confirmMessage(): string {
    let message = '¿Está seguro que desea enviar la solicitud?';
    if (Sede.Shared.Context.ConfirmMessage !== '' && this.props.mode !== CreatePqrComponentMode.CreateAnonymous) {
      message = Sede.Shared.Context.ConfirmMessage;
    }
    return message
  }

  get showNumeroRadicadoSalida(): boolean {
    if (this.state.model.IdTramite === TipoTramite.AporteAclaracion) {
      return true;
    }
    if (this.state.model.IdTramite === TipoTramite.AporteAmpliacion) {
      return true;
    }
    if (this.state.model.IdTramite === TipoTramite.AporteInformacion) {
      return true;
    }
    return false;
  }

  get show_SolicitudDenunciante(): boolean {
    const idTipoContacto: number = this.contactTypeId;
    if (idTipoContacto == TipoContacto.Congresista) {
      if (this.state.model.IdTramite === TramiteEnum.DerechoPeticion) {
        return true;
      }
      if (this.state.model.IdTramite === TramiteEnum.DenunciaFiscal) {
        return true;
      }
    }
    return false;
  }
  //#endregion

  public render(): JSX.Element {

    const deleteDraft = () => {
      showConfirmation('Eliminar borrador', '¿Está seguro que desea eliminar el borrador?', () => {
        ensureFetch(GuidLegacy.IsValid(this.sessionId) ? this._service.deleteAnonymousDraftAsync(this.sessionId) : this._service.deleteDraftAsync(), () => {
          window.location.reload();
        })
      })
    }

    const procesoX = {
      GetEntityItems: (entityId: string, callback: (result: any) => void) => {
        ensureFetch(this._service.getProcesoxRuntimeItemsAsync(entityId, []), callback);
      },
      ExecuteFunction: (functionId: string, inputs: { [ key: string ]: any }, calllback: (value: string) => void) => {
        ensureFetch(this._service.executeProcesoxFunctionAsync(functionId, inputs), (result) => {
          if (typeof calllback === 'function') {
            calllback(result);
          }
        });
      },
      ExecuteFunctionAsync: async (functionId: string, inputs: { [ key: string ]: any }) => {
        return new Promise((resolve) => {
          ensureFetch(this._service.executeProcesoxFunctionAsync(functionId, inputs || {}), (result) => {
            resolve(result);
          });
        })
      },
      GetEntityItemsAsync: async (entityId: string) => {
        return this._service.getProcesoxRuntimeItemsAsync(entityId, []);
      },
      Paginate: async (request: IDataTableRequest, options: IPaginationBase<any>) => {
        return paginateDataAsync(request, options);
      }
    };

    return (
      <div className='ms-Grid'>
        <div className='ms-Grid-row'>
          <div className="ms-Grid-col ms-u-sm12">
            <h1 className='ms-font-xl ms-fontWeight-semibold' >{this.props.mode === CreatePqrComponentMode.CreateAnonymous ? 'Formular solicitud anónima' : 'Formular solicitud'}</h1>
          </div>
        </div>
        {this.props.mode === CreatePqrComponentMode.CreateAnonymous && Sede.Shared.Context.InformacionSolicitudAnonima &&
          <div className='ms-Grid-row'>
            <div className='ms-Grid-col ms-u-sm12'>
              <div dangerouslySetInnerHTML={{ __html: Sede.Shared.Context.InformacionSolicitudAnonima }}></div>
            </div>
          </div>
        }
        {this.props.mode !== CreatePqrComponentMode.CreateAnonymous && Sede.Shared.Context.InformacionSolicitudAutenticado &&
          <div className='ms-Grid-row'>
            <div className="ms-Grid-col ms-u-sm12">
              <div dangerouslySetInnerHTML={{ __html: Sede.Shared.Context.InformacionSolicitudAutenticado }}></div>
            </div>
          </div>
        }
        {this.props.mode !== CreatePqrComponentMode.CreateAnonymous && Sede.Shared.Context.EnableContactRequesterType &&
          <ComboBox
            label='Tipo de solicitante'
            selectedKey={this.entityTypeId}
            onChange={(_, value) => this._changeModelComboBox('IdTipoEntidad', value)}
            options={this.state.data.tiposSolicitante}
            useComboBoxAsMenuWidth={true}
            disabled={true}
          />
        }
        {this.defaultTramiteId === 0 && <Row>
          <Column size={12}>
            <TooltipHost content={this.state.descripcionTramite}>
              <ComboBox
                label='Tipo de petición'
                autoComplete='on'
                selectedKey={this.state.model.IdTramite}
                onChange={(_, value) => this._onChangeTramite(value, {}, true)}
                options={this.state.data.tramitesCO}
                errorMessage={this.state.errors[ 'IdTramite' ]}
                useComboBoxAsMenuWidth={true}
                required={true}
              />
            </TooltipHost>
          </Column>
        </Row>}

        {this.props.mode !== CreatePqrComponentMode.CreateAnonymous && Sede.Shared.Context.EnableRiskField &&
          <div className='ms-Grid-row'>
            <div className="ms-Grid-col ms-u-sm12">
              <Checkbox
                label={Sede.Shared.Context.SubjectRiskField}
                checked={this.state.model.RepresentaRiesgo}
                onChange={this._onChangeCheckboxRiesgo.bind(this)}
              />
            </div>
          </div>
        }

        {Sede.Shared.Context.TextInformation &&
          <div className='ms-Grid-row'>
            <div className='ms-Grid-col ms-u-sm12'>
              <div dangerouslySetInnerHTML={{ __html: Sede.Shared.Context.TextInformation }}></div>
            </div>
          </div>
        }

        {this.state.showClasificacionPQRS && <>
          {this.state.keywordsDataSource.length > 0 && this.props.mode !== CreatePqrComponentMode.CreateAnonymous &&
            <Row>
              <Column size={12}>
                <TooltipHost content={Sede.Shared.Context.ToolTipFieldWord}>
                  <TextField
                    label="Palabra clave del trámite o servicio"
                    onChange={
                      (_, option) => {
                        // Establecer las palabras clave seleccionadas
                        let keywords = [ ...this.state.palabrasClave ];
                        const keyword = option;
                        const index = keywords.indexOf(keyword);
                        if (index < 0) {
                          keywords.push(keyword);
                        }
                        else if (index >= 0) {
                          keywords = keywords.filter(o => o != keyword);
                        }

                        let clasificacionesPQRS: IComboBoxOption[] = [];
                        clasificacionesPQRS = keywords.length > 0 ? this._clasificaciones.filter(o => !isNullOrEmpty(o.PalabrasClave) && o.Activo && o.RegistroWeb && this.containsKeywords(keywords, o.PalabrasClave)).map(o => ({ key: o.IdClasificacionPQRS, text: o.Nombre })) : this._clasificaciones.filter(o => (o.Activo && o.RegistroWeb)).map(o => ({ key: o.IdClasificacionPQRS, text: o.Nombre }));

                        this.setState({
                          clasificacionesPQRS,
                          //palabrasClave: keywords
                        });
                      }
                    }
                  />
                </TooltipHost>
              </Column>
            </Row>}
          <Row>
            <Column size={12}>
              <TooltipHost content={Sede.Shared.Context.ToolTipFieldType}>
                <ComboBox
                  label='Seleccione el eje temático de su petición'
                  autoComplete='on'
                  useComboBoxAsMenuWidth={true}
                  options={this.state.clasificacionesPQRS}
                  errorMessage={this.state.errors[ 'IdClasificacionPQRS' ]}
                  onChange={(_, value) => this._onChangeClasificacionPQR(value)}
                  selectedKey={this.state.model.IdClasificacionPQRS}
                  required={this.state.showClasificacionPQRS} />
              </TooltipHost>
            </Column>
          </Row>
          {Sede.Shared.Context.ShowSectionField &&
            <Row>
              <Column size={12}>
                <TextField
                  label={Sede.Shared.Context.NameSectionField}
                  disabled={true}
                  readOnly={true}
                  value={this.state.model.Seccion}
                />
              </Column>
            </Row>
          }
        </>
        }

        {
          this.state.showCampoOtro &&
          <div className='ms-Grid-row'>
            <div className='ms-Grid-col ms-u-sm12 block'>
              <TextField
                placeholder='Otro'
                label='Otro'
                errorMessage={this.state.errors[ 'OtroClasificacionPQR' ]}
                maxLength={128}
                required={this.state.showCampoOtro}
                onChange={(_: any, value: string) => this._changeModelTextField('OtroClasificacionPQR', value)}
                value={this.state.model.OtroClasificacionPQR}
              />
            </div>
          </div>
        }

        {
          this.showNumeroRadicadoSalida &&
          <div className='ms-Grid-row'>
            <div className='ms-Grid-col ms-u-sm12 block'>
              <TextField
                placeholder="Número del radicado de salida a responder"
                label='Número radicado de salida'
                ariaLabel='Número radicado de salida a responder'
                errorMessage={this.state.errors[ 'NumeroRadicadoSalida' ]}
                autoFocus={true}
                required={this.showNumeroRadicadoSalida}
                onChange={(_: any, value: string) => {
                  this.setState({
                    NumeroRadicadoSalida: value
                  });
                }}
                value={this.state.NumeroRadicadoSalida}
              />
            </div>
          </div>
        }

        {
          this.props.mode === CreatePqrComponentMode.Create && this.show_SolicitudDenunciante &&
          <div>
            <div className='ms-Grid-row'>
              <div className="ms-Grid-col ms-u-sm6">
                <ComboBox
                  label='Actua en'
                  autoComplete='on'
                  selectedKey={this.state.model.RadicaRepresentante ? 1 : 2}
                  onChange={(_, value) => this._changeActuaEn(value)}
                  options={this.state.data.tiposActuacion}
                  useComboBoxAsMenuWidth={true}
                  defaultSelectedKey={2}
                  required={true}
                />
              </div>
              {
                this.state.model.RadicaRepresentante &&
                <div className="ms-Grid-col ms-u-sm6" id="checkbox-denunciante-anonimo">
                  <Checkbox
                    label='Denunciante anónimo'
                    checked={this.state.model.DenuncianteAnonimo}
                    onChange={this._changeModelCheckBox.bind(this, 'DenuncianteAnonimo')}
                  />
                </div>
              }
            </div>
            {
              this.state.model.RadicaRepresentante && !this.state.model.DenuncianteAnonimo && <div className='ms-Grid-row'>
                <div className="ms-Grid-col ms-u-sm6">
                  <TextField
                    placeholder={this.state.labelsDenunciante.nombre}
                    label={this.state.labelsDenunciante.nombre}
                    maxLength={128}
                    onChange={(_: any, value: string) => this._changeModelTextField('NombresApoderado', value)}
                    errorMessage={this.state.errors[ 'NombresApoderado' ]}
                    value={this.state.model.NombresApoderado} />
                </div>
                <div className="ms-Grid-col ms-u-sm6">
                  <TextField
                    placeholder={this.state.labelsDenunciante.apellido}
                    label={this.state.labelsDenunciante.apellido}
                    maxLength={128}
                    onChange={(_: any, value: string) => this._changeModelTextField('ApellidosApoderado', value)}
                    errorMessage={this.state.errors[ 'ApellidosApoderado' ]}
                    value={this.state.model.ApellidosApoderado} />
                </div>
              </div>
            }
            {
              this.state.model.RadicaRepresentante && !this.state.model.DenuncianteAnonimo && <div className='ms-Grid-row'>
                <div className="ms-Grid-col ms-u-sm6">
                  <ComboBox
                    selectedKey={this.state.model.IdTipoIdentificacionApoderado}
                    label={this.state.labelsDenunciante.tipoIdentificacion}
                    useComboBoxAsMenuWidth={true}
                    autoComplete='on'
                    options={this.state.data.tiposIdentificacion}
                    errorMessage={this.state.errors[ 'IdTipoIdentificacionApoderado' ]}
                    onChange={(_, value) => this._changeModelComboBox('IdTipoIdentificacionApoderado', value)}
                  />
                </div>
                <div className="ms-Grid-col ms-u-sm6">
                  <TextField
                    placeholder={this.state.labelsDenunciante.numeroIdentificacion}
                    label={this.state.labelsDenunciante.numeroIdentificacion}
                    maxLength={15}
                    onChange={(_: any, value: string) => this._changeModelTextField('IdentificacionApoderado', value)}
                    errorMessage={this.state.errors[ 'IdentificacionApoderado' ]}
                    value={this.state.model.IdentificacionApoderado} />
                </div>
              </div>
            }
            {
              this.state.model.RadicaRepresentante && !this.state.model.DenuncianteAnonimo && <div className='ms-Grid-row'>
                <div className="ms-Grid-col ms-u-sm6">
                  <TextField
                    placeholder={this.state.labelsDenunciante.email}
                    label={this.state.labelsDenunciante.email}
                    maxLength={128}
                    onChange={(_: any, value: string) => this._changeModelTextField('EmailApoderado', value)}
                    errorMessage={this.state.errors[ 'EmailApoderado' ]}
                    value={this.state.model.EmailApoderado} />
                </div>
                <div className="ms-Grid-col ms-u-sm6">
                  <ComboBox
                    label='Persona con discapacidad'
                    autoComplete='on'
                    selectedKey={this.state.model.SolicitanteConDiscapacidad ? 1 : 2}
                    onChange={(_, value) => this._changePersonaDiscapacidad(value)}
                    options={this.state.data.tiposDiscapacidad}
                    useComboBoxAsMenuWidth={true}
                    defaultSelectedKey={2}
                  />
                </div>
              </div>
            }
          </div>
        }
        <div className='ms-Grid-row'>
          <div className="ms-Grid-col ms-u-sm12">
            <TextField
              placeholder={Sede.Shared.Context.EnabledSubjectDescription == true ? 'Formule la solicitud, pregunta o consulta de manera clara, precisa y breve (Este campo admite máximo ' + this._limiteAsunto + ' caracteres)' : ''}
              label='Describa aquí su solicitud y/o pretensión'
              maxLength={this._limiteAsunto}
              minLength={10}
              multiline={true}
              required={true}
              style={{ minHeight: '40px', backgroundColor: 'white!important' }}
              onChange={(_: any, value: string) => this._changeModelTextField('Asunto', value)}
              errorMessage={this.state.errors[ 'Asunto' ]}
              value={this.state.model.Asunto} />
          </div>
        </div>
        {
          (this._campoObservacion) &&
          <div className='ms-Grid-row'>
            <div className="ms-Grid-col ms-u-sm12">
              <TextField
                placeholder={'Observaciones'}
                label='Observaciones'
                maxLength={4096}
                minLength={10}
                multiline={true}
                required={false}
                style={{ minHeight: '40px', backgroundColor: 'white!important' }}
                onChange={(_: any, value: string) => this._changeModelTextField('Observaciones', value)}
                errorMessage={this.state.errors[ 'Observaciones' ]}
                value={this.state.model.Observaciones} />
            </div>
          </div>
        }
        <div className='ms-Grid-row'>
          <div className="ms-Grid-col ms-u-sm12">
            {this.renderMetadata()}
          </div>
        </div>

        {
          this.props.mode == CreatePqrComponentMode.CreateAnonymous &&
          <div>
            <TextField
              placeholder='Correo eléctronico para recibir respuestas y notificaciones del proceso.'
              label='Correo eléctronico (Opcional)'
              maxLength={128}
              onChange={(_: any, value: string) => this._changeModelTextField('Email', value)}
              errorMessage={this.state.errors[ 'Email' ]}
              value={this.state.model.Email}
              style={{ padding: '0px 8px' }}
            />
          </div>
        }
        {
          !isNullOrEmpty(this.state.procesoxFunction) && <FunctionHost
            code={this.state.procesoxFunction}
            state={this.state.model.CustomMetadata || {}}
            onChanged={values => {
              this.setState({
                model: {
                  ...this.state.model,
                  CustomMetadata: values
                }
              });
            }}
            variables={{
              ProcesoX: procesoX
            }}
            value={this.state.model.CustomMetadata || {}}
            errors={this.state.errors}
            onValidate={validator => this.setState({ functionHostValidator: validator })}
          />
        }
        {
          this.state.model.IdRadicadoEntrada > 0 && <ReFileUploader
            title='Anexos'
            attachments={this.state.attachments}
            onAttachmentsChanged={attachments => this.setState({ attachments })}
            radicadoId={this.state.model.IdRadicadoEntrada}
            onRetryCompleted={mainFile => { }}
            allowRemove={true}
            service={this._pqrWebService}
            sessionId={this.sessionId}
          />
        }

        {
          this.props.mode === CreatePqrComponentMode.CreateAnonymous &&
          <div className='ms-Grid-row'>
            <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12" style={{ paddingTop: '8px' }}>
              <Checkbox
                label='Autorizo publicación respuesta en página web'
                checked={this.state.model.AutorizaRespuestaCorreoElectronicoOSitioWeb}
                onChange={this._changeModelCheckBox.bind(this, 'AutorizaRespuestaCorreoElectronicoOSitioWeb')}
                onRenderLabel={() => <div>
                  <Label>
                    Autorizo publicación respuesta en página web
                  </Label>
                </div>}
              />
            </div>
          </div>
        }
        <div className='ms-Grid-row'>
          <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12" style={{ paddingTop: '8px' }}>
            <small style={{ color: 'red' }}> {this.state.errors[ 'terminos' ]}</small>
          </div>
        </div>
        <div className='ms-Grid-row'>
          <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12" style={{ paddingTop: '8px' }}>
            <ReCaptchaComponent
              onInitialize={component => {
                this._recaptcha = component;
                setTimeout(this._recaptcha.initialize, 2000);
              }}
            />
            <small style={{ color: 'red' }}> {this.state.errors[ 'recaptcha' ]}</small>
          </div>
        </div>
        <Row>
          <Column size={4} style={{ paddingTop: '15px' }}>
            {
              this.state.model.IdRadicadoEntrada > 0 && <DefaultButton
                text='Eliminar borrador'
                onClick={deleteDraft}
              />
            }
          </Column>
          <Column size={8} style={{ paddingTop: '15px', textAlign: 'right' }}>
            <PrimaryButton
              text={this.state.model.IdRadicadoEntrada > 0 ? 'Enviar' : 'Continuar'}
              onClick={this._saveAsync.bind(this)}
            />
            <span>&nbsp;&nbsp;</span>
            <DefaultButton
              text='Volver'
              onClick={() => window.location.href = '#/home'}
            />
          </Column>
        </Row>
        <Panel
          isOpen={this.state.disclaimer.show}
          hasCloseButton={false}
          type={PanelType.largeFixed}
          headerText={this.state.disclaimer.title}
          isFooterAtBottom={true}
          onRenderFooterContent={() => <>
            {!this.state.disclaimer.isPersonalData && <div className='ms-Grid-row'>

              <div className='ms-Grid-col ms-u-sm12' style={{ textAlign: 'right' }}>
                <DefaultButton text='Volver' primary={false} onClick={() => this.setState({ disclaimer: { show: false, text: '', title: '', isPersonalData: false } })} />
              </div>
            </div>
            }
            {this.state.disclaimer.isPersonalData &&
              <div className='ms-Grid-col ms-u-sm12' style={{ display: 'flex', textAlign: 'right' }}>
                <DefaultButton text='Aceptar' primary={true} onClick={() => this.setState({
                  model: {
                    ...(this.state.model as any),
                    AutorizaTratamientoDatosPersonales: true
                  },
                  disclaimer: { show: false, text: '', title: '', isPersonalData: false }
                })} />
                <span>&nbsp;&nbsp;</span>
                <DefaultButton text='Cerrar' primary={false} onClick={() => {
                  window.location.href = '#/home';
                  window.location.reload();
                }
                } />
              </div>
            }
          </>}
          closeButtonAriaLabel='Cerrar'>
          <div dangerouslySetInnerHTML={{ __html: this.state.disclaimer.text !== '' && this.state.disclaimer.text !== null ? this.state.disclaimer.text.split('####').join('<br /><br />') : '' }}></div>
        </Panel>
      </div >
    );
  }

  private renderMetadata() {

    const customComponents = {
      RadicadoEntradaViewer: () => <></>

    }

    if (this.state.procesoxEntryPoint != null) {
      return <UXForm
        form={this.state.procesoxEntryPoint}
        customComponents={{}}
        activityInstance={null}
      />
    }

    if (isNullOrEmpty(this.state.tramite.Props?.OnRenderRadicadoEntradaMetadata)) {
      return <LayoutEditorComponent
        mode='exe'
        scope='web'
        idObjeto={this.state.model.IdTramite}
        idObjetoAsUrlParam={false}
        metadataService={this._service.getTramiteMetadataAsync.bind(this._service)}
        getMetadataColumnTypes={undefined}
        getCitiesService={this._service.getAllCitiesAsync.bind(this._service)}
        getDepartmentsService={this._service.getAllDepartmentsAsync.bind(this._service)}
        getCountriesService={this._service.getAllCountriesAsync.bind(this._service)}
        readExternalMetadataService={this._service.readExternalMetadataAsync.bind(this._service)}
        executeCustomCodeService={this._service.executeAsync.bind(this._service)}
        getCategoryMetadataService={this._service.getMetadataCategoryByNameAsync.bind(this._service)}
        getMetadataOptionsService={this._service.getOptionsByIdMetadatoAsync.bind(this._service)}
        getContactsService={this._service.paginateContactsAsync.bind(this._service)}
        onChangeValues={this._onChangeMetadata.bind(this)}
        ref={e => this._editorMetadatosComponent = e}
        values={this.state.model.ValoresMetadatos}
        model={() => {
          return this.state.model
        }}
      />;
    } else {
      return this.state.tramite?.Props?.OnRenderRadicadoEntradaMetadata === '-'
        ? <></>
        : <>
          {
            console.log('SCR')
          }
          <ScriptComponent
            script={this.state.tramite.Props?.OnRenderRadicadoEntradaMetadata}
            props={{ values: this.state.model.CustomMetadata || {} }}
            onChange={value => {
              this.setState({
                model: {
                  ...this.state.model,
                  CustomMetadata: value
                }
              });
            }}
            sdk={{
              metadataService: this._service.getTramiteMetadataAsync.bind(this._service),
              getEntitiesService: this._service.getContactEntitiesAsync.bind(this._service),
              getCitiesService: this._service.getAllCitiesAsync.bind(this._service),
              getDepartmentsService: this._service.getAllDepartmentsAsync.bind(this._service),
              getCountriesService: this._service.getAllCountriesAsync.bind(this._service),
              getCategoryMetadataService: this._service.getMetadataCategoryByNameAsync.bind(this._service),
              getMetadataOptionsService: this._service.getOptionsByIdMetadatoAsync.bind(this._service),
              readExternalMetadataService: this._service.readExternalMetadataAsync.bind(this._service),
              executeCustomCodeService: this._service.executeAsync.bind(this._service),
              validateModel: validateObject.bind(this),
              showConfirmation: showConfirmation.bind(this),
              getValidator: (() => validator),
              DateTime: DateTime
            }}
            ref={o => this._scriptComponentRef = o}
          />
        </>;
    }
  }

  protected _changeStateTextField(property: string, value: string | number) {
    this.setState({
      ...(this.state as any),
      [ property ]: value
    });
  }

  private _onChangeCheckboxRespuesta(ev?: React.FormEvent<HTMLElement | HTMLInputElement>, checked?: boolean): void {
    this.setState({
      model: {
        ...this.state.model,
        PrefiereRespuestaFisica: !checked
      }
    });
  }

  private _onChangeCheckboxRiesgo(ev?: React.FormEvent<HTMLElement | HTMLInputElement>, checked?: boolean): void {
    this.setState({
      model: {
        ...this.state.model,
        RepresentaRiesgo: checked
      }
    });
  }

  protected async _changeActuaEn(value?: IComboBoxOption): Promise<void> {
    this.setState({
      model: {
        ...this.state.model,
        RadicaRepresentante: Number(value.key) === 1,
      }
    });
  }

  protected async _changePersonaDiscapacidad(value?: IComboBoxOption): Promise<void> {
    this.setState({
      model: {
        ...this.state.model,
        SolicitanteConDiscapacidad: Number(value) === 1,
      }
    });
  }

  protected async _onChangeTramite(value: IComboBoxOption, customMetadata: IDictionary<any>, mostrarPanel: boolean): Promise<void> {

    const tramite: ITramite = { ...this._tramites.find(o => o.IdTramite === Number(value.key)) || defaultITramite() };
    const isProcesox = tramite != null && tramite.Funcion != null && tramite.Funcion != '';

    //let [ metadatos, clasificaciones, procesoxFunction ]: [ IMetadatoAsociado[], IClasificacionPQRS[], any ] = [ [], [], [] ];
    try {
      const [ metadatos, clasificaciones, procesoxFunction ] = await Promise.all([
        this._service.getTramiteMetadataAsync(Number(value.key)),
        tramite.IdTipoAsignacionTramite == TipoAsignacionTramiteEnum.Clasificacion ? this._service.getClasificacionPQRSAsync(Number(value.key), this.contactTypeId) : [],
        isProcesox && !isNullOrEmpty(Sede.Shared.ProcesoxUrl) ? this._service.getProcesoxFunction(tramite.Componente) : new Promise<any>(resolve => resolve({}))
      ]);

      let clasificacionesPQRS: IComboBoxOption[] = [];
      let showClasificacionPQRS: boolean = false;
      let keywordsDataSource: IComboBoxOption[] = [];
      this._clasificaciones = clasificaciones;
      if (clasificaciones != null && clasificaciones.length > 0) {

        let allKeywords = new List<IClasificacionPQRS>(clasificaciones).Where(o => !isNullOrEmpty(o.PalabrasClave)).Select(o => o.PalabrasClave.trim().toUpperCase().split('|')).ToArray();
        let flatKeywords = allKeywords.reduce((accumulator, value) => accumulator.concat(value), []);
        keywordsDataSource = new List<string>(flatKeywords).Distinct().OrderBy(o => o).ToArray().map(o => ({ key: o, text: o }));

        clasificacionesPQRS = clasificaciones.filter(o => (o.Activo && o.RegistroWeb)).map(o => ({ key: o.IdClasificacionPQRS, text: o.Nombre }));
        if (clasificacionesPQRS.length > 0) {
          showClasificacionPQRS = true;
        }
      }

      const renderScript = tramite.Props?.OnRenderRadicadoEntradaMetadata;
      if (tramite.Props != undefined) {
        tramite.Props.OnRenderRadicadoEntradaMetadata = '';
      }

      let entryPoint: CForm = null;
      if (GuidLegacy.IsValid(tramite.Props?.ProcesoxProjectId) && GuidLegacy.IsValid(tramite.Props?.ProcesoxFormVersionId)) {
        const schema = await $_.svc.ProcesoX.ProjectSvc.getPageAsync(Guid.parse(tramite.Props.ProcesoxFormVersionId));
        const page = new JSPage({ schema, engine: null });
        entryPoint = await page.loadEntryPointV1Async();
        entryPoint.values = this.state.model.CustomMetadata || {};
        entryPoint.onInvokeRender = () => {
          this.setState({
            model: {
              ...this.state.model,
              CustomMetadata: entryPoint.values
            }
          });
        };
      }

      this.setState({
        metadatos,
        model: {
          ...this.state.model,
          IdTramite: Number(value.key),
          //Limpiar formulario
          Anexos: []
        },
        clasificacionesPQRS,
        showClasificacionPQRS,
        descripcionTramite: tramite.Descripcion,
        tramite,
        procesoxEntryPoint: entryPoint,
        keywordsDataSource,
        disclaimer: {
          show: mostrarPanel && this.props.mode !== CreatePqrComponentMode.CreateAnonymous,
          title: tramite.Nombre,
          text: tramite.Descripcion,
          isPersonalData: false
        }
      }, () => {
        this.setState({
          procesoxFunction,
          tramite: {
            ...this.state.tramite,
            Props: {
              ...this.state.tramite.Props,
              OnRenderRadicadoEntradaMetadata: renderScript
            }
          },
          model: {
            ...this.state.model,
            CustomMetadata: customMetadata || {}
          }
        });
        this._onChangeClasificacionPQR({
          key: this.state.model.IdClasificacionPQRS
          , text: this.state.model.ClasificacionPQRS
        });
      });

    } catch (error) {
      showError('Se ha producido un error.')
    }
  }

  protected async _onChangeClasificacionPQR(value: IComboBoxOption): Promise<void> {

    const clasificacion: IClasificacionPQRS = { ...this._clasificaciones.find(o => o.IdClasificacionPQRS === Number(value.key)) };

    this.setState({
      model: {
        ...(this.state.model as any),
        IdClasificacionPQRS: value.key,
        Seccion: clasificacion.SeccionUsuarioResponsable
      },
      showCampoOtro: clasificacion.HabilitarOtraClasificacionPQR
    });
  }

  private _onChangeMetadata(values: IValorMetadato[]): void {
    var customMetadata = {};

    for (let i = 0; i < values.length; i++) {
      if (values[ i ].Valor != undefined)
        customMetadata[ values[ i ].Codigo ] = values[ i ].Valor;
    }

    this.setState({
      model: {
        ...this.state.model,
        ValoresMetadatos: values,
        CustomMetadata: customMetadata
      }
    });
  }

  private containsKeywords = (keywords: string[], itemKeyWords: string): boolean => {
    for (let i = 0; i < keywords.length; i++) {
      if (itemKeyWords.toUpperCase().includes(keywords[ i ].toUpperCase())) {
        return true;
      }
    }
    return false;
  }

  private async _saveAsync(): Promise<void> {

    let model = JSON.parse(JSON.stringify(this.state.model));
    model.Anonima = this.props.mode === CreatePqrComponentMode.CreateAnonymous;
    model.OficioRemisorio = void 0;
    model.ComprobanteEntrega = void 0;
    model.CopiasRadicadoEntrada = void 0;
    model.AnexosDescripcionDocumental = void 0;
    model.MetadatosAsociados = void 0;

    //Validar que el contacto tenga direccion
    if (model.PrefiereRespuestaFisica) {
      let direccion: string = sessionStorage.getItem('ioip.pqr-web.session.direccion');
      if (!direccion) {
        alert('Debe proporcionar una dirección de residencia para recibir respuesta física, por favor actualice sus datos y vuelva a intentarlo.');
        return;
      }
    }

    // Valida que exista el numero de salida para el aporte
    if (this.showNumeroRadicadoSalida && isNullOrEmpty(this.state.NumeroRadicadoSalida)) {
      alert('Por favor ingrese el número del radicado de salida a responder.');
      return;
    }

    // Validar campos del formulario
    let validations = {
      Asunto: [ validator.required(true), validator.maxLength(4096), validator.minLength(10) ],
      IdTramite: [ validator.invalid(0, 'Campo requerido') ]
    };

    if (this.state.showClasificacionPQRS) {
      validations[ 'IdClasificacionPQRS' ] = [ validator.invalid(0, 'Campo requerido') ];
    }

    if (this.state.showCampoOtro && isNullOrEmpty(this.state.model.OtroClasificacionPQR)) {
      alert('Por favor ingrese el campo Otro.');
      return;
    }

    if (model.Anonima) {
      if (!isNullOrEmpty(model.Email)) {
        validations[ 'Email' ] = [
          validator.maxLength(128),
          validator.email()
        ];
      }
    }
    else {
      if (sessionStorage.getItem('ioip.pqr-web.session.idcontacto') != null)
        model.idContacto = parseInt(sessionStorage.getItem('ioip.pqr-web.session.idcontacto'));
    }

    if (model.RadicaRepresentante && !model.DenuncianteAnonimo) {
      if (isNullOrEmpty(model.NombresApoderado) && isNullOrEmpty(model.ApellidosApoderado) && isNullOrEmpty(model.IdentificacionApoderado) && isNullOrEmpty(model.EmailApoderado)) {
        alert('Debe registrar al menos un dato del denunciante en caso de que no sea anónimo.')
        return;
      }
      validations[ 'IdTipoIdentificacionApoderado' ] = [ validator.custom(() => {
        const result = new ValidationResult();
        if (model.IdTipoIdentificacionApoderado === 0 && !isNullOrEmpty(model.IdentificacionApoderado)) {
          result.hasError = true;
          result.errorMessage = 'Campo requerido';
          return result;
        }
        return result;
      }) ];
      if (!isNullOrEmpty(model.EmailApoderado)) {
        validations[ 'EmailApoderado' ] = [ validator.email() ];
      }
    }

    const vMetadatos = this.state.tramite.Props?.OnRenderRadicadoEntradaMetadata
      ? this._scriptComponentRef.isValid()
      : this.state.procesoxEntryPoint != null
        ? this.state.procesoxEntryPoint.validate()
        : this.state.tramite.IdTipoEjecucionGestionTramite === TipoEjecucionGestionTramiteEnum.Proceso
          ? this.state.functionHostValidator(this.state.model.CustomMetadata)
          : await this._editorMetadatosComponent.validate();

    const isModelValid = validateObject(model, validations, (errors) => this.setState({ errors })) && vMetadatos;

    // Validar ProcesoX
    let vProcesoX = true;
    if (isModelValid && vProcesoX) {
      if (this.showNumeroRadicadoSalida) {
        model.IdRadicadoSalidaVinculado = await this._searchRSVinculadoAsync();
        if (model.IdRadicadoSalidaVinculado === 0) {
          return;
        }
        if (model.IdRadicadoSalidaVinculado === -1) {
          alert('El radicado de entrada principal no fue encontrado, por favor verifique que el número de radicado esté correcto.');
          return;
        }
      }

      const resultCaptcha = this._recaptcha.isValid();
      if (resultCaptcha.isCaptchaValid === false) {
        this.setState({
          errors: {
            recaptcha: 'Debe completar la validación de seguridad'
          }
        });
        return;
      }

      if (this.state.model.IdEstadoActual === EstadoRadicado.Borrador) {

        showConfirmation('Registrar petición', this.confirmMessage, async () => {
          const request = GuidLegacy.IsValid(this.sessionId)
            ? this._service.completeAnonymousDraftAsync(this.sessionId, model, resultCaptcha.recaptchaToken)
            : this._service.completeDraftAsync(model, resultCaptcha.recaptchaToken);
          ensureFetch(request, (response) => {
            if (model.Anonima)
              alert(`Su solicitud fue creada exitosamente. Para realizar la consulta del estado de la solicitud por favor guarde el número del radicado ${response.NumeroRadicado} y el código de consulta ${response.CodigoConsulta}`);
            else
              alert(`Radicado de entrada creado correctamente con número ${response.NumeroRadicado}.`);
            window.location.href = '#/home';
          })


        });

      } else {
        try {
          const result = GuidLegacy.IsValid(this.sessionId)
            ? await this._service.saveAnonymousRadicadoEntradaDraftAsync(this.sessionId, model, resultCaptcha.recaptchaToken)
            : await this._service.saveRadicadoEntradaDraftAsync(model, resultCaptcha.recaptchaToken);
          if (this.props.mode === CreatePqrComponentMode.Create) {
            window.location.reload();
          } else {
            window.location.href = `#/create-pqr/anonymous/${result.SessionId}`;
            window.location.reload();
          }
        } catch (ex) {
          const error = `Ocurrió un error : ${(ex as any).exceptionMessage}`;
          alert(error);
        }
      }

    }
  }

  private async _searchRSVinculadoAsync(): Promise<number> {
    let result: IRadicadoSalida[] = [];
    let request: { Numero: string; } = { Numero: '' };
    request.Numero = this.state.NumeroRadicadoSalida;
    result = (await this._service.advanceSearchAsync(request)).filter(o => o.NumeroRadicado === request.Numero);
    if (result != undefined) {
      if (result.length === 0) {
        alert('El radicado de salida buscado no existe.');
        return 0;
      } else {
        switch (this.state.model.IdTramite) {
          case Number(TipoTramite.AporteAclaracion):
            if (result[ 0 ].IdTipoRespuestaPQRS != Number(TipoRespuestaPQRS.Aclaracion)) {
              alert('El radicado buscado no corresponde a una solicitud de aclaración.');
              result = [];
            }
            break;

          case Number(TipoTramite.AporteAmpliacion):
            if (result[ 0 ].IdTipoRespuestaPQRS != Number(TipoRespuestaPQRS.Ampliacion)) {
              alert('El radicado buscado no corresponde a una solicitud de ampliación.');
              result = [];
            }
            break;

          case Number(TipoTramite.AporteInformacion):
            if (result[ 0 ].IdTipoRespuestaPQRS != Number(TipoRespuestaPQRS.Informacion)) {
              alert('El radicado buscado no corresponde a una solicitud de información.');
              result = [];
            }
            break;

          default:
            result = [];
            alert('El radicado buscado no está en un estado autorizado para recibir aportes.');
            break;
        }
        if (result.length === 1) {
          return result[ 0 ].IdRadicadoSalida;
        }
        return 0;
      }
    }
    return -1;
  }

  public componentWillUnmount() {

  }

  private async _getTokenB2C() {

    if (this._authProvider !== undefined) {
      if (this._authProvider.authenticationState == AuthenticationState.Authenticated) {
        const token = await this._authProvider.getIdToken();
        if (token !== undefined)
          sessionStorage.setItem('ioip.pqr-web.session.token', token.idToken.rawIdToken);
      }
    }
  }

}

export default CrearSolicitudComponent;